/**
 * @module no-i18next-provider
 * @internal
 */
import React from 'react';
import { initI18nBase, ICU } from '@wix/wix-i18n-config';
import { ExternalTranslationsContext, useApi } from '@wix/comments-ooi-client';
import { identity } from 'lodash';
let i18nInstance;
const icuOptions = {
    formats: {
        date: {
            wcShortDate: { month: 'short', day: '2-digit' },
            wcFullDate: { month: 'short', day: '2-digit', year: 'numeric' },
        },
    },
};
/**
 * When consumer already has wix-i18n-config there is a clash of contexts. This
 * is temporary solution wich works around by skipping the Provider.  Do not
 * suggest as default solution as it pokes around wix-18n-config internals...
 */
export default function WixCommentsTranslationsNoI18nextProvider(props) {
    const [locale = 'en', messages, wcBaseParams] = useApi((state) => {
        var _a;
        return [
            (_a = state.baseParams) === null || _a === void 0 ? void 0 : _a.language,
            state.translations,
            state.baseParams,
        ];
    });
    // this means that controller is initialized
    if (wcBaseParams && !i18nInstance) {
        const icu = new ICU(icuOptions);
        i18nInstance = initI18nBase({
            locale,
            messages,
        }, { icu });
    }
    const t = (i18nInstance === null || i18nInstance === void 0 ? void 0 : i18nInstance.t.bind(i18nInstance)) || identity;
    return (React.createElement(ExternalTranslationsContext.Provider, { value: React.useMemo(() => ({
            t,
        }), [t]) }, props.children));
}
//# sourceMappingURL=translations-provider-no-i18next-provider.js.map